export default __webpack_public_path__ + "static/media/carpetfootstool.a3b042cb.jpg";